import { patchReplace } from "../../../helpers/patchDoc";
import { useGetFiledMailByGraphIdQuery, usePatchFiledMailMutation } from "../../../services/useremails";
import { FiledEmailType } from "../../../types/EmailType";

export type GetEmailByGraphIdProps = {
    data: FiledEmailType | null,
    isFetching: boolean,
    isError: boolean,
    error: Error | string | null,
    reload: (e?: any) => void,
    updateProject: (projectId: string) => Promise<any>
};

const useEmail = (graphMailId: string) : GetEmailByGraphIdProps => {
    const { data, isFetching, isError, error, refetch } = useGetFiledMailByGraphIdQuery({ graphId: graphMailId });
    const [patchMail] = usePatchFiledMailMutation();

    const reload = (e) => {
        if (e && typeof (e.preventDefault)) {
            e.preventDefault();
        }

        refetch();
    };

    const updateProject = (projectId) =>
        patchMail({ graphId: graphMailId, projectId }).unwrap();

    return {
        data: data || {},
        isFetching,
        isError,
        error,
        reload,
        updateProject
    };
};

export default useEmail;